var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    {
      staticClass: "header",
      attrs: {
        id: "main-navigation",
        role: "navigation",
        "aria-label": "Main site navigation",
      },
    },
    [
      _c(
        "v-app-bar",
        {
          attrs: {
            color: "primary",
            dense: "",
            app: "",
            "clipped-left": "",
            extended: "",
            "extension-height": "6",
          },
          scopedSlots: _vm._u([
            {
              key: "extension",
              fn: function () {
                return [
                  _c("page-loading-component", {
                    attrs: { "aria-label": "Page loading indicator" },
                  }),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c(
            "v-tooltip",
            {
              attrs: { bottom: "" },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function (ref) {
                    var on = ref.on
                    var attrs = ref.attrs
                    return [
                      _c(
                        "v-btn",
                        _vm._g(
                          _vm._b(
                            {
                              attrs: {
                                icon: "",
                                large: "",
                                "aria-label": _vm.$t(
                                  "components.header.gameName"
                                ),
                                to: _vm.homeRoute,
                              },
                            },
                            "v-btn",
                            attrs,
                            false
                          ),
                          on
                        ),
                        [
                          _c(
                            "v-avatar",
                            { attrs: { size: "32px", tile: "" } },
                            [
                              _c("img", {
                                attrs: {
                                  src: _vm.iconUrl,
                                  alt: "Gods of Zushin logo",
                                },
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            },
            [
              _vm._v(" "),
              _c("span", [
                _vm._v(_vm._s(_vm.$t("components.header.gameName"))),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c("notifications", {
            attrs: { "aria-label": "User notifications" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("cookies"),
      _vm._v(" "),
      _c("deactivated"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }